<template>
  <div 
    class="information-row mb-2 p-4" 
  >
    <div :style="{ backgroundColor: backgroundColor, color: textColor, }" class="row m-0 h-100 information-content">
      <div class="col-12 col-lg-7 col-xl-7 p-2 p-lg-3 p-xl-3 top-and-left-information-row">
        <div class="w-100 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
          <div class="text-center text-lg-left text-xl-left information-title d-flex align-items-center justify-content-start">
            {{ title }}
          </div>
        </div>
        <div :class="addEllipsis" class="text-left pt-2 information-description">
          {{ description }}
        </div>
      </div>
      <div class="col-12 col-lg-5 col-xl-5 p-0 py-3 py-md-0 py-lg-0 py-xl-0 pr-md-3 d-flex justify-content-center align-items-center">
        <a
          v-if="toLink && toLink.length > 0"
          :href="toLink"
          target="_blank"
        >
          <v-btn
              class="button-class px-lg-5 px-xl-5"
              outlined
              rounded
              :color="textColor"
              :width="buttonWidth"
              :height="buttonHeight"
          >
            {{ buttonTitle }}
          </v-btn>
        </a>
        <router-link
          v-else
          :to="toRoute"
        >
          <v-btn
              class="button-class px-lg-5 px-xl-5"
              outlined
              rounded
              :color="textColor"
              :width="buttonWidth"
              :height="buttonHeight"
          >
            {{ buttonTitle }}
          </v-btn>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      description: String,
      backgroundColor: String,
      buttonTitle: String,
      toRoute: Object,
      toLink: String,
      textColor: {
        type: String,
        default: '#fff',
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
      },
      buttonWidth() {
        return this.isMobile ? 240 : this.$vuetify.breakpoint.md ? 340 : 380;
      },
      buttonHeight() {
        return this.isMobile ? 40 : this.$vuetify.breakpoint.md ? 60 : 80;
      },
      addEllipsis() {
        return !this.isMobile ? "limit-lines-4" : "";
      }
    },
  }
</script>

<style scoped>
  .information-row {
    width: 100%;
    min-height: 300px;
    background-color: rgba(217, 217, 217, 0.20);
    border-radius: 5px;
    font-family: GeomGraphic;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    align-items: center;
  }

  .information-content {
    border-radius: 5px;
  }

  .top-and-left-information-row {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .information-title {
    min-height: 110px;
    min-width: 200px;
    max-width: 750px;
    font-size: clamp(24px, 2vw, 50px);
  }

  .information-description {
    width: 100%;
    min-height: 106px;
    font-size: clamp(14px, 2vw, 20px);
  }

  .button-class {
    border-radius: 60px;
    font-size: clamp(15px, 2vw, 26px);
  }
</style>